import { apiRequest, UseRequest } from '../utils/useAPIRequest';
import { capitalizeFirstLetter } from '../utils/utils';
import constant from '../utils/constant';
import { userStore, businessStore } from '../stores';

const login = async payload => {
	try {
		localStorage.clear();
		const response = await UseRequest({
			url: '/users/user/login',
			method: 'post',
			payload,
		});

		if (response?.status === 200) {
			const { token, user, onbordingDone, unDoneReviews } = response.data || {};
			userStore.setUser(user);
			userStore.setUnDoneReviews(unDoneReviews);
			userStore.setOnBoardingDone(onbordingDone);
			localStorage.setItem('token', token);
			userStore.setActivated(true);
			userStore.setLoggedIn(true);
			businessStore.setBId(user.business._id);
			businessStore.setBusinesses(user.businesses);
			userStore.setHasMobileApp(!user.banner);
			return { status: constant.Success };
		}
	} catch (error) {
		const { data, status } = error?.response || {};

		if (status === 403 && data.activated === false) {
			userStore.setActivated(false);
			userStore.setUserId(data.userId);
			return { status: constant.Success };
		}

		if (status === 403 && data.activated === true && data.approved === false) {
			return { status: constant.InReview };
		}

		return {
			status: constant.Failed,
			errorMessage: data?.message || 'Network error',
		};
	}
};

const resetPassword = async payload => {
	try {
		await UseRequest({
			url: '/users/user/reset-password',
			method: 'post',
			payload,
		});
		userStore.setToken('');
		userStore.setLoggedIn(false);
		return { status: constant.Success };
	} catch (error) {
		const { data } = error.response || {};
		return { status: constant.Failed, errorMessage: data.message };
	}
};

const getPermissions = async () => {
	try {
		let { data } = await UseRequest({
			url: '/permissions/business',
			method: 'get',
		});
		data = data.map(perm => {
			perm.permissions = perm.permissions.map(value => {
				value.name = capitalizeFirstLetter(value.name);
				return value;
			});
			return perm;
		});
		userStore.setPermissions(data);
		return { status: constant.Success };
	} catch (error) {
		const { data } = error.response || {};
		return { status: constant.Failed, errorMessage: data.message };
	}
};
const getUser = async id => {
	try {
		const { data, status } = await UseRequest({
			url: `/users/user/${id}`,
			method: 'get',
		});
		if (status === constant.Success) {
			userStore.setUser(data);
			return { status: constant.Success };
		}
	} catch (error) {
		const { data } = error.response || {};
		return { status: constant.Failed, errorMessage: data.message };
	}
};
const forgotPassword = async email =>
	await apiRequest({
		url: `/users/user/forget-password/${email.replace(/\s+/g, '')}`,
		method: 'get',
		constantStore: [
			{ store: userStore.setEmail, value: email.replace(/\s+/g, '') },
		],
	});

const resendCode = async userId =>
	await apiRequest({
		url: `/users/user/resend/${userId}/user`,
		method: 'get',
	});

const validateForgetPasswordToken = async token => {
	const email = JSON.parse(localStorage.getItem(constant.RouteParams)).email;
	localStorage.setItem(constant.RouteParams, '');
	const { data, status, errorMessage } = await apiRequest({
		url: `/users/user/validate/${email}/${token}/user`,
		method: 'get',
		responseStore: [{ store: userStore.setToken, value: 'token' }],
	});
	if (status === constant.Success) {
		userStore.setUser(data.user);
		localStorage.setItem('token', data.token);
		userStore.setLoggedIn(true);
		return { status: constant.Success };
	}
	return { status, errorMessage };
};
const setPin = async payload => {
	try {
		const { status } = await apiRequest({
			url: '/users/user/set-pin',
			method: 'patch',
			payload,
		});
		if (status === constant.Success) {
			await getUser(userStore.user._id);
			return { status: constant.Success };
		}
	} catch (error) {
		const { data } = error.response || {};
		return { status: constant.Failed, errorMessage: data.message };
	}
};

const forgotPin = async payload =>
	await apiRequest({
		url: '/users/user/forget-pin',
		method: 'post',
		payload,
	});

const changePassword = async payload =>
	await apiRequest({
		url: '/users/user/change-password',
		method: 'patch',
		payload,
	});

const changePin = async payload =>
	await apiRequest({
		url: '/users/user/change-pin',
		method: 'post',
		payload,
	});
const activateUser = async token => {
	const { status, errorMessage, data } = await apiRequest({
		url: `/users/user/activate/${userStore.userId}/${token}/user`,
		method: 'get',
		constantStore: [
			{ store: userStore.setActivated, value: 'true' },
			{ store: userStore.setOnBoardingDone, value: 'false' },
		],
	});
	if (status === constant.Success) {
		// userStore.setUser(data.user);
		// localStorage.setItem('token', data.token);
		// userStore.setLoggedIn(true);
		return { status: constant.Success, data };
	}
	return { status, errorMessage };
};

const UserController = {
	login,
	getUser,
	changePassword,
	getPermissions,
	activateUser,
	forgotPassword,
	validateForgetPasswordToken,
	resetPassword,
	resendCode,
	setPin,
	changePin,
	forgotPin,
};

export default UserController;
